import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TermsAndConditionsEffect } from './state';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([TermsAndConditionsEffect])],
})
export class TermsAndConditionsDataAccessModule {}
